import type { ReactNode } from "react";

export interface PageHeroAsideProps {
  children: ReactNode;
}

/**
 * La columna de la DERECHA de una portada: la pieza viva.
 *
 * ── Qué puede ir aquí ────────────────────────────────────────────────
 * El vídeo circular de `/franquicias`, el disco de descuento de
 * `/paquetes`, y lo que venga. La condición no es estética: lo que se
 * ponga aquí NO puede decir nada que la columna de texto no diga ya,
 * porque este contenedor lo saca del árbol de accesibilidad. Un dato que
 * solo viva en esta caja es un dato que no existe para quien navega con
 * lector de pantalla.
 *
 * (El disco de `/paquetes` cumple: los dos porcentajes que enseña están
 * escritos con letras en la entradilla.)
 *
 * ── Y tiene que saber quedarse quieto ────────────────────────────────
 * Lo que va aquí se mueve, así que consulta `useHeroMotion` y con
 * movimiento reducido se queda fijo. Este contenedor no puede imponerlo
 * —no sabe qué le meten dentro—, pero es la regla del sitio: la resuelven
 * `CircleVideo` y `PackagesHeroDial`, y cualquier pieza nueva la copia de
 * ahí.
 *
 * ── En móvil va DEBAJO, no arriba ────────────────────────────────────
 * `PageHero` la coloca en la segunda fila de la rejilla. Encima del
 * titular empujaría el mensaje fuera de la primera pantalla del teléfono
 * para dejar sitio a decoración, que es justo al revés de lo que hace
 * falta. Debajo, quien baja se la encuentra y quien no, ya leyó lo
 * importante.
 */
export function PageHeroAside({ children }: PageHeroAsideProps) {
  return (
    <div aria-hidden="true" className="flex justify-center lg:justify-end">
      {children}
    </div>
  );
}
